






















































































































































import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import ApiHelper from 'api-helper';
import Toast from '@common/helpers/toast';
import { ROLE_LIST, Roles } from '@common/app.config';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import ContentLayout from '@components/layouts/Content.vue';
import memberIcon from '@/assets/img/memberIcon.svg';
import PopupAddClinic from '@/components/common/PopupAddClinic.vue';
import PopupSetPassword from '@/components/common/PopupSetPasswordMember.vue';
import PopupConfirm from '@/components/common/PopupConfirm.vue';
import DragDropFileUpload from '@/components/common/DragDropFileUpload.vue';
import ToggleSwitch from '@/components/common/ToggleSwitch.vue';
import BackgroundGallery from '@/components/common/BackgroundGallery.vue';
import { backgroundErrorMessage } from '@/common/helpers/background-error';
import { identity, pickBy } from 'lodash';

@Component({
  components: {
    ContentLayout,
    PopupAddClinic,
    PopupSetPassword,
    PopupConfirm,
    DragDropFileUpload,
    ToggleSwitch,
    BackgroundGallery,
  },
  filters: {
  },
  data() {
    return {
      iconHeader: memberIcon,
    };
  },
})
export default class DetailMember extends Vue {

  private get isCanChangeClinic() {
    return (
      (this.currentUser.isSuperAdminRole ||
        this.currentUser.isAdminRole ||
        this.currentUser.isDocumentRole ||
        this.currentUser.isCSRole) && (
        this.formData.role == 'clinic_admin' ||
        this.formData.role == 'super_admin'
      )
    );
  }

  /**
   * True only when a doctor is viewing their OWN account through this page
   * (i.e. the Sidebar's "アカウント" link, which always points at
   * `/members/${currentUser.id}`). False for every other visit to this same
   * route/component — an admin/superAdmin editing another member, or a
   * doctor row opened from elsewhere — so the block never leaks into those
   * flows and existing logic for them is untouched.
   */
  private get isDoctorOwnAccount(): boolean {
    return this.currentUser.role === Roles.doctor
      && String(this.currentUser.id) === String(this.$route.params.id);
  }
  @State((state) => state.auth.currentUser) currentUser!: any;
  submitting = false;
  isSubmitDelete = false;
  formData = {
    email: '',
    name: '',
    role: '',
    clinic_id: '',
  };
  defaultFormData = {
    email: '',
    name: '',
    role: '',
  };
  private clinic: any = {};
  private roleListOption = ROLE_LIST;

  // Background settings (task No.77) — doctor's own "アカウント" page only.
  private backgrounds: any[] = [];
  private backgroundEnabled = false;
  private currentBackgroundId: number | null = null;
  private isSubmitingBackground = false;
  private pendingDeleteBackground: any = null;

  setPassword() {
    this.hiddenPopup('popup-set-password');
  }

  beforeOpen() {
    document.documentElement.style.overflow = 'hidden';
  }

  beforeClose() {
    document.documentElement.style.overflow = 'auto';
  }

  created() {
    this.getInfo();
    library.add(faTrashAlt);
    dom.watch();

    if (this.isDoctorOwnAccount) {
      this.fetchBackgroundSettings();
      // No.77: another tab/device (e.g. one mid video-call) may create/
      // delete/select a background while this screen is open — refetch so
      // the list/selection here does not go stale either.
      this.$on('UpdateBackgroundSetting', this.onBackgroundSettingUpdated);
    }
  }

  beforeDestroy() {
    this.$off('UpdateBackgroundSetting', this.onBackgroundSettingUpdated);
  }
  getInfo() {
    ApiHelper.getApi('MemberApi')
      .detail(this.$route.params.id, { id: this.$route.params.id })
      .then((res) => {
        this.formData = JSON.parse(JSON.stringify(res));
        if (res.clinics && res.clinics[0]) {
          this.clinic = res.clinics[0];
          this.formData.clinic_id = res.clinics[0].id;
        }
        this.defaultFormData = JSON.parse(JSON.stringify(res));
      });
  }

  setClinic(clinic) {
    if (clinic && clinic.id) {
      this.clinic = clinic;
      this.formData.clinic_id = clinic.id;
      this.hiddenPopup('popup-add-clinic');
      return;
    }
  }

  private async onBackgroundSettingUpdated() {
    await this.fetchBackgroundSettings();
  }
  // Background settings (task No.77) — doctor's own "アカウント" page only.
  private backgroundErrorMessage(error): string {
    return backgroundErrorMessage(error);
  }

  /**
   * `ManagerResource` (backing this page's own `/members/:id` API) does not
   * expose `background_id`/`background_enabled`, so those two fields are
   * read from `DoctorApi.getBackgroundSetting` instead — a dedicated
   * doctor-self endpoint (`GET /${id}/background-setting`) — rather than
   * `DoctorApi.getDetail`, whose `/${id}` route sits behind role:clinic_admin
   * server-side and would 403 a doctor reading their own record.
   */
  private async fetchBackgroundSettings() {
    try {
      const response = await ApiHelper.getApi('DoctorApi').getBackgroundSetting(this.currentUser.id);
      this.backgroundEnabled = !!response.background_enabled;
      this.currentBackgroundId = response.background_id || null;

      await this.fetchBackgrounds();
    } catch (error) {
      Toast.error(this.backgroundErrorMessage(error));
    }
  }

  private async fetchBackgrounds() {
    try {
      const response = await ApiHelper.getApi('DoctorApi').getBackgrounds(this.currentUser.id);
      this.backgrounds = response.data;
    } catch (error) {
      Toast.error(this.backgroundErrorMessage(error));
    }
  }

  private async onChangeBackgroundFile(file) {
    if (this.isSubmitingBackground) {
      return;
    }
    try {
      this.isSubmitingBackground = true;
      const formDataUpload = new FormData();
      formDataUpload.append('background_file', file);
      await ApiHelper.getApi('DoctorApi').uploadBackground(this.currentUser.id, formDataUpload);
      await this.fetchBackgrounds();
      Toast.success('背景画像をアップロードしました');
    } catch (error) {
      Toast.error(this.backgroundErrorMessage(error));
    } finally {
      this.isSubmitingBackground = false;
    }
  }

  private async selectBackground(background) {
    if (this.isSubmitingBackground) {
      return;
    }
    try {
      this.isSubmitingBackground = true;
      await ApiHelper.getApi('DoctorApi').updateBackgroundSetting(this.currentUser.id, {
        background_id: background.id,
      });
      this.currentBackgroundId = background.id;
      Toast.success('背景を設定しました');
    } catch (error) {
      Toast.error(this.backgroundErrorMessage(error));
    } finally {
      this.isSubmitingBackground = false;
    }
  }

  private async onToggleBackgroundEnabled(checked) {
    if (this.isSubmitingBackground) {
      return;
    }
    // Turning the feature on without a chosen image stores enabled=true with
    // a null background, and the call then silently renders no background.
    if (checked && !this.currentBackgroundId) {
      Toast.error('先に背景画像を選択してください。');

      return;
    }
    try {
      this.isSubmitingBackground = true;
      await ApiHelper.getApi('DoctorApi').updateBackgroundSetting(this.currentUser.id, {
        background_enabled: checked,
      });
      this.backgroundEnabled = checked;
    } catch (error) {
      Toast.error(this.backgroundErrorMessage(error));
    } finally {
      this.isSubmitingBackground = false;
    }
  }

  private confirmDeleteBackground(background) {
    this.pendingDeleteBackground = background;
    this.$modal.show('confirmDeleteBackground');
  }

  private cancelDeleteBackground() {
    this.pendingDeleteBackground = null;
    this.$modal.hide('confirmDeleteBackground');
  }

  private async deleteBackground() {
    if (this.isSubmitingBackground) {
      return;
    }
    try {
      this.isSubmitingBackground = true;
      await ApiHelper.getApi('DoctorApi')
        .deleteBackground(this.currentUser.id, this.pendingDeleteBackground.id);
      this.$modal.hide('confirmDeleteBackground');
      this.pendingDeleteBackground = null;
      await this.fetchBackgrounds();
      Toast.success('削除しました');
    } catch (error) {
      Toast.error(this.backgroundErrorMessage(error));
    } finally {
      this.isSubmitingBackground = false;
    }
  }

  private hiddenPopup(name) {
    this.$modal.hide(name);
  }
  private submit(invalid) {
    if (invalid) {
      (this.$refs.memberForm as any).validate();
      return;
    }
    this.submitting = true;
    ApiHelper.getApi('MemberApi')
      .update(this.$route.params.id, this.formData)
      .then((res) => {
        this.formData = JSON.parse(JSON.stringify(res));
        if (res.clinics && res.clinics[0]) {
          this.clinic = res.clinics[0];
          this.formData.clinic_id = res.clinics[0].id;
        }
        this.defaultFormData = JSON.parse(JSON.stringify(res));
        Toast.success('更新しました');
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      })
      .finally(() => {
        this.submitting = false;
      });
  }

  private deleteMember() {
    this.isSubmitDelete = true;
    ApiHelper.getApi('MemberApi')
      .removeMember(this.$route.params.id)
      .then((res) => {
        Toast.success('削除しました');
        this.$router.push('/members');
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      })
      .finally(() => {
        this.isSubmitDelete = false;
      });
  }

  private showPopup(event, name) {
    event.preventDefault();
    event.stopPropagation();

    this.$modal.show(name);
  }

  private handleCancel() {
    const queryParams = pickBy({
      id: this.$route.query.id || '',
      name: this.$route.query.name || '',
      name_kana: this.$route.query.name_kana || '',
      role: this.$route.query.role || '',
      clinic_name: this.$route.query.clinic_name || '',
      page: this.$route.query.page || '1',
    }, identity);

    return this.$router.push({
      path: '/members',
      query: queryParams,
    });
  }
}
